/**
 * Unfortunately this looks like a bug in the GetItemTree logic that is
 * stripping the “t.dw” field input from the final call. Four our purposes
 * you may need to rely on whether the “dw_prel” field is > 0 to determine
 * if the item is a debitware items or not. This should work fine for our purposes.
 */
export default pkg => {
  return pkg != null && pkg.dw_prel != null && pkg.dw_prel > 0;
};
